module.exports = __webpack_public_path__ + "a20b6cb69e86fa0728337dea49cdc9e0.svg";